{
  "name": "gasolina-radar-front",
  "version": "1.6.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "npm run i18n:check && ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "i18n:check": "node ./scripts/i18n-check.mjs"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/platform-browser": "^20.3.0",
    "@angular/router": "^20.3.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0",
    "qrcode": "^1.5.4",
    "@vercel/analytics": "^1.5.0",
    "@vercel/speed-insights": "^1.2.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.8",
    "@angular/cli": "^20.3.8",
    "@angular/compiler-cli": "^20.3.0",
    "@types/jasmine": "~5.1.0",
    "@types/qrcode": "^1.5.5",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2"
  }
}